import React, { useState } from 'react';
import LocationHeader from './components/LocationHeader';
import OpeningHours from './components/OpeningHours';
import ContactInfo from './components/ContactInfo';
import FacilitiesList from './components/FacilitiesList';
import UserReviews from './components/UserReviews';
import LocationMap from './components/LocationMap';
import RelatedLocations from './components/RelatedLocations';
import FacilityImages from './components/FacilityImages';
import FAQSection from './components/FAQSection';
import PoliciesSection from './components/PoliciesSection';
import PromotionsSection from './components/PromotionsSection';
import FooterNav from './components/FooterNav';
import './LocationDetailPage.css';

const LocationDetailPage = () => {
  const [saved, setSaved] = useState(false);

  return (
    <div className="location-detail-page">
      {/* Hero Photo Gallery */}
      <LocationHeader />

      {/* Floating Action Bar */}
      <div className="floating-action-bar">
        <button className="fab-btn" onClick={() => setSaved(!saved)}>
          <span className="fab-icon">{saved ? '❤️' : '🤍'}</span>
          <span>{saved ? 'Saved' : 'Save'}</span>
        </button>
        <button className="fab-btn">
          <span className="fab-icon">📤</span>
          <span>Share</span>
        </button>
        <a href="https://maps.google.com" target="_blank" rel="noopener noreferrer" className="fab-btn fab-btn--primary">
          <span className="fab-icon">📍</span>
          <span>Directions</span>
        </a>
        <a href="tel:+11234567890" className="fab-btn fab-btn--primary">
          <span className="fab-icon">📞</span>
          <span>Call</span>
        </a>
      </div>

      {/* Main Content Grid */}
      <div className="location-content-grid">
        {/* Left Column - Main Content */}
        <div className="location-main-content">
          {/* Title & Quick Info */}
          <div className="location-title-section">
            <div className="location-title-row">
              <h1 className="location-title">Cozy Baby Cafe</h1>
              <div className="verified-badge">
                <span className="verified-icon">✓</span>
                Verified
              </div>
            </div>
            <div className="location-meta">
              <span className="rating">
                <span className="star">★</span> 4.8
                <span className="review-count">(127 reviews)</span>
              </span>
              <span className="meta-dot">·</span>
              <span className="location-type">Babyville</span>
              <span className="meta-dot">·</span>
              <span className="badge badge--green">Baby-friendly</span>
              <span className="badge badge--blue">Superhost</span>
            </div>
          </div>

          {/* Host Info */}
          <div className="host-section">
            <img 
              src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop&crop=face" 
              alt="Sarah" 
              className="host-avatar"
            />
            <div className="host-info">
              <h3>Hosted by Sarah</h3>
              <p>Joined 2023 · Superhost</p>
            </div>
            <button className="message-host-btn">Message Host</button>
          </div>

          <div className="section-divider" />

          {/* What this place offers */}
          <FacilitiesList />

          <div className="section-divider" />

          {/* Photo Gallery */}
          <FacilityImages />

          <div className="section-divider" />

          {/* Reviews */}
          <UserReviews />

          <div className="section-divider" />

          {/* Map */}
          <LocationMap />

          <div className="section-divider" />

          {/* FAQ */}
          <FAQSection />

          <div className="section-divider" />

          {/* Policies */}
          <PoliciesSection />
        </div>

        {/* Right Column - Sticky Sidebar */}
        <div className="location-sidebar">
          <div className="sidebar-card">
            <div className="sidebar-card__header">
              <span className="sidebar-card__rating">
                <span className="star">★</span> 4.8
              </span>
              <span className="sidebar-card__reviews">127 reviews</span>
            </div>

            <OpeningHours />
            
            <div className="sidebar-divider" />
            
            <ContactInfo />

            <div className="sidebar-actions">
              <a href="https://maps.google.com" target="_blank" rel="noopener noreferrer" className="sidebar-btn sidebar-btn--primary">
                <span>📍</span> Get Directions
              </a>
              <a href="tel:+11234567890" className="sidebar-btn sidebar-btn--secondary">
                <span>📞</span> Call Now
              </a>
            </div>

            <p className="sidebar-note">
              <span>🛡️</span> This location is verified and meets our safety standards
            </p>
          </div>

          {/* Promotions */}
          <PromotionsSection />
        </div>
      </div>

      {/* Related Locations */}
      <div className="related-section-wrapper">
        <RelatedLocations />
      </div>

      <FooterNav />
    </div>
  );
};

export default LocationDetailPage;
